import {formatCurrency} from '../stores/JSHelper';
import {AccountSummaryResponse} from '../stores/types';
import format from 'date-fns/format';

export const barChartDataDailyTraffic = (summary: AccountSummaryResponse) => [
  {
    name: 'Wallet Balance',
    data: summary.walletStats.topWallets.map((wallet) => wallet.balance),
  },
];

export const barChartOptionsDailyTraffic = (summary: AccountSummaryResponse) => ({
  chart: {
    toolbar: {
      show: true,
    },
  },
  tooltip: {
    style: {
      fontSize: '12px',
      fontFamily: undefined,
      backgroundColor: '#000000',
    },
    onDatasetHover: {
      style: {
        fontSize: '12px',
        fontFamily: undefined,
      },
    },
    theme: 'dark',
  },
  xaxis: {
    categories: summary.walletStats.topWallets.map((w) => w.accountName),
    show: true,
    labels: {
      show: true,
      style: {
        colors: '#A3AED0',
        fontSize: '14px',
        fontWeight: '500',
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: true,
    color: 'black',
    labels: {
      show: true,
      formatter: (value) => formatCurrency(value, 'INR', true),
      style: {
        colors: '#CBD5E0',
        fontSize: '14px',
      },
    },
  },
  grid: {
    show: false,
    strokeDashArray: 5,
    yaxis: {
      lines: {
        show: true,
      },
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  fill: {
    type: 'gradient',
    gradient: {
      type: 'horizontal',
      shadeIntensity: 1,
      opacityFrom: 0.7,
      opacityTo: 0.9,
      colorStops: [
        [
          {
            offset: 0,
            color: '#4318FF',
            opacity: 1,
          },
          {
            offset: 100,
            color: 'rgba(67, 24, 255, 1)',
            opacity: 0.28,
          },
        ],
      ],
    },
  },
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 10,
      columnWidth: '30px',
    },
  },
});

export const pieChartOptions = {
  labels: ['Your files', 'System', 'Empty'],
  colors: ['#4318FF', '#6AD2FF', '#EFF4FB'],
  chart: {
    width: '50px',
  },
  states: {
    hover: {
      filter: {
        type: 'none',
      },
    },
  },
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: false,
  },
  hover: {mode: null},
  plotOptions: {
    donut: {
      expandOnClick: false,
      donut: {
        labels: {
          show: false,
        },
      },
    },
  },
  fill: {
    colors: ['#4318FF', '#6AD2FF', '#EFF4FB'],
  },
  tooltip: {
    enabled: true,
    theme: 'dark',
    style: {
      fontSize: '12px',
      fontFamily: undefined,
      backgroundColor: '#000000',
    },
  },
};

export const pieChartData = [63, 25, 12];

export const barChartOptionsCustomCDTrends = (categories, showDataLabels = true) => {
  return {
    chart: {
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
        fontFamily: undefined,
        backgroundColor: '#000000',
      },
      theme: 'dark',
      onDatasetHover: {
        style: {
          fontSize: '12px',
          fontFamily: undefined,
        },
      },
    },
    xaxis: {
      type: 'category',
      categories,
      show: false,
      labels: {
        rotateAlways: true,
        rotate: -45,
        show: true,
        style: {
          colors: '#A3AED0',
          fontSize: '14px',
          fontWeight: '500',
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: [
      {
        show: true,
        color: 'black',
        labels: {
          show: true,
          formatter: (value) => formatCurrency(value, 'INR', true),
          style: {
            fontSize: '14px',
            fontWeight: '500',
          },
        },
      },
      {
        show: false,
        labels: {
          show: true,
          formatter: (value) => formatCurrency(value, 'INR', true),
          style: {
            fontSize: '14px',
            fontWeight: '500',
          },
        },
      },
      {
        opposite: true,
        show: true,
        labels: {
          formatter: (value) => `${value}%`,
          style: {
            fontSize: '14px',
            fontWeight: '500',
          },
        },
      },
      {
        opposite: true,
        show: false,
        labels: {
          style: {
            fontSize: '14px',
            fontWeight: '500',
          },
        },
      },
    ],
    stroke: {
      width: [0, 0, 4, 4],
    },
    legend: {
      show: true,
    },
    dataLabels: {
      enabled: showDataLabels,
      enabledOnSeries: [2, 3],
      offsetY: -5,
      formatter: (val) => val + '%',
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        colors: ['#6844AD'],
      },
      background: {
        enabled: true,
        foreColor: '#fff',
        borderRadius: 10,
        padding: 8,
        opacity: 0.9,
        borderWidth: 1,
        borderColor: '#fff',
      },
    },
  };
};

export const barChartOptionsWeeklyRevenue = (categories) => {
  return {
    chart: {
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    // colors:['#ff3322','#faf']
    tooltip: {
      style: {
        fontSize: '12px',
        fontFamily: undefined,
        backgroundColor: '#000000',
      },
      theme: 'dark',
      onDatasetHover: {
        style: {
          fontSize: '12px',
          fontFamily: undefined,
        },
      },
    },
    xaxis: {
      type: 'category',
      categories,
      show: false,
      labels: {
        rotateAlways: true,
        rotate: -45,
        show: true,
        style: {
          colors: '#A3AED0',
          fontSize: '14px',
          fontWeight: '500',
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: true,
      color: 'black',
      labels: {
        show: true,
        formatter: (value) => formatCurrency(value, 'INR', true),
        style: {
          colors: '#A3AED0',
          fontSize: '14px',
          fontWeight: '500',
        },
      },
    },

    grid: {
      borderColor: 'rgba(163, 174, 208, 0.3)',
      show: true,
      yaxis: {
        lines: {
          show: false,
          opacity: 0.5,
        },
      },
      row: {
        opacity: 0.5,
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    fill: {
      type: 'solid',
      colors: ['#5E37FF', '#6AD2FF', '#E1E9F8'],
    },
    legend: {
      show: true,
    },
    colors: ['#5E37FF', '#6AD2FF', '#E1E9F8'],
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        columnWidth: '20px',
      },
    },
  };
};

export const lineChartOptionsTotalSpent = {
  legend: {
    show: true,
  },

  theme: {
    mode: 'light',
  },
  chart: {
    type: 'line',

    toolbar: {
      show: false,
    },
  },

  dataLabels: {
    enabled: true,
    formatter: (value) => formatCurrency(value, 'INR', true),
  },
  stroke: {
    curve: 'smooth',
  },

  tooltip: {
    style: {
      fontSize: '12px',
      fontFamily: undefined,
      backgroundColor: '#000000',
    },
    theme: 'dark',
    x: {
      format: 'dd/MM/yy HH:mm',
    },
  },
  grid: {
    show: false,
  },
  xaxis: {
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    labels: {
      style: {
        colors: '#A3AED0',
        fontSize: '12px',
        fontWeight: '500',
      },
    },
    type: 'text',
    range: undefined,
    categories: ['Today', 'Last 7 Days', 'Last 30 Days', 'Last 90 Days'],
  },

  yaxis: {
    show: true,
    labels: {
      formatter: (value) => formatCurrency(value, 'INR', true),
    },
  },
};
